import { useMyNftsByPartner, useMyOngoingParticipationsNftsByPartner } from '@capsicum/socios-core';

export const useNCWPartnerNfts = (filterPartnerId: string) => {
	const { data: myNfts, error: nftsErrors, isLoading: isLoadingNfts } = useMyNftsByPartner(filterPartnerId);

	const {
		data: ongoingParticipationNfts,
		error: ongoingParticipationErrors,
		isLoading: isLoadingParticipations
	} = useMyOngoingParticipationsNftsByPartner(filterPartnerId);

	return {
		errors: [nftsErrors, ongoingParticipationErrors],
		isLoading: isLoadingNfts || isLoadingParticipations,
		nfts: [...(ongoingParticipationNfts || []), ...(myNfts || [])]
	};
};
